import { Component } from '@angular/core';

import { HasId } from '../../../../shared/basic-data-management/has-id.interface';

import { EntityCheckboxListComponent } from '../../../../shared/checkbox-list/components/entity-checkbox-list.component';

class Etat implements HasId {
	id!: number;
	label!: string;
}

@Component({
	selector: 'etat-parc-checkbox-list',
	templateUrl: '../../../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class EtatParcCheckboxListComponent extends EntityCheckboxListComponent<Etat> {
	// Label du champ
	override label = "Etat du parc"
	
	// Label de l'option neutre
	override wildcardOptionLabel = "Tous"
	
	// Fonction determinant le label d'une entite
	override getEntityLabel = (value: Etat) => value.label;
	
	// Fonction determinant quelle(s) entites(s) doivent etre preselectionnees par defaut
	override shouldBeSelectedByDefaut = (_value: Etat) => true; 
	
	// Entites (NB: dans le cas present, l'id sert aussi de valeur finale
	override entities: Etat[] = [
		{
			id: 1,
			label: 'En exploitation'
		},
		{
			id: 0,
			label: 'En construction'
		}
	];

	constructor( //
	) {
		super();
	}
}